import SIZES_JSON from '../iconography/iconography_sizes.json';
export var getPaymentIconSizeWidth = function getPaymentIconSizeWidth(size) {
  return SIZES_JSON["payment-icon-width-".concat(size)];
};
export var getPaymentIconSizeHeight = function getPaymentIconSizeHeight(size) {
  return SIZES_JSON["payment-icon-height-".concat(size)];
};